import { AuthenticationService } from '../../shared/services/authentication.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NavigationService } from '../../shared/services/navigation.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavItem } from './nav-item.model';
import * as moment from 'moment';
import { APP_VERSION, SERVICE_DESK_URL_BASE } from '../constants';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit, OnDestroy {

  version = APP_VERSION

  loadTrackingView = false;
  customerView     = false;

  isCollapsed               = true;
  isSideMenuContainerShow   = false;
  isSideMenuShow            = false;
  iShowUserMenuDetail       = false;
  iShowHotspotMenuDetail    = false;
  iShowLocalLoadsMenuDetail = false;
  iShowMonitoringMenuDetail = false;
  isUserDropdownOpen        = false;
  subMenuOpen               = false;
  selectedMenu: NavItem               = null;

  eventsSubscription: Subscription;

  headerClickCount = 0;
  headerLastClick  = moment();

  serviceDeskUrl = SERVICE_DESK_URL_BASE;

  navItems: Array<NavItem> = [];
  homeUri = this.navigation.home().getUri()

  userProfileSubscription: Subscription;

  constructor(
    private navigation: NavigationService,
    public authService: AuthenticationService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute
  ) {

    this.eventsSubscription = router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {

        let loadTrackingView    = false;
        let customerView        = false;
        let userDashboardView   = false;
        let hotspotTrackingView = false;
        let localLoadsView      = false;
        let monitoringView      = false;

        if (this.route.root.firstChild) {
          const currentRoute = this.route.root.firstChild.routeConfig;

          if (currentRoute && currentRoute.data && currentRoute.data.loadTrackingView) {
            loadTrackingView = true;
          }

          if (currentRoute && currentRoute.data && currentRoute.data.customerView) {
            customerView = true;
          }

          if (currentRoute && currentRoute.data && currentRoute.data.userDashboardView) {
            userDashboardView = true;
          }

          if (currentRoute && currentRoute.data && currentRoute.data.hotspotTrackingView) {
            hotspotTrackingView = true;
          }

          if (currentRoute && currentRoute.data && currentRoute.data.localLoadsView) {
            localLoadsView = true;
          }

          if (currentRoute && currentRoute.data && currentRoute.data.monitoringView) {
            monitoringView = true;
          }
        }

        this.loadTrackingView = loadTrackingView;
        this.customerView     = customerView;

        if (userDashboardView) {
          this.iShowUserMenuDetail = true;
        }

        if (hotspotTrackingView) {
          this.iShowHotspotMenuDetail = true;
        }

        if (localLoadsView) {
          this.iShowLocalLoadsMenuDetail = true;
        }

        if (monitoringView) {
          this.iShowMonitoringMenuDetail = true;
        }
      }
    });
  }

  ngOnInit() {
    this.refreshNavItems();
    this.userProfileSubscription = this.authService.userProfileBehavior().subscribe(userProfile => {
      this.refreshNavItems();
    });
  }

  refreshNavItems() {
    this.navItems    = [
      {
        translationKey: 'nav.configuration',
        displayed: () => this.authService.isAuthenticated() && (this.authService.canManageConfiguration() || this.authService.canReadConfiguration()),
        iconClass: 'fa fa-cog',
        items: [
          {
            translationKey: 'nav.user-management',
            iconClass: 'fa fa-user',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManageUsers() ||
              this.authService.canManageRoles() ||
              this.authService.canManagePermissions(),
            items: [
              {
                translationKey: 'nav.user-dashboard.administrators',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageUsers(),
                navigation: this.navigation.administrators().list()
              }, {
                translationKey: 'nav.user-dashboard.chep-managers',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageUsers(),
                navigation: this.navigation.chepManagers().list()
              }, {
                translationKey: 'nav.user-dashboard.chep-service-rep',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageUsers(),
                navigation: this.navigation.chepServiceRep().list()
              }, {
                translationKey: 'nav.user-dashboard.plant-managers',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageUsers(),
                navigation: this.navigation.plantManagers().list()
              }, {
                translationKey: 'nav.user-dashboard.pod-reviewers',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageUsers(),
                navigation: this.navigation.podReviewers().list()
              }, {
                translationKey: 'nav.user-dashboard.blue-tracking-managers',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageRoles(),
                navigation: this.navigation.overdueManagers().list()
              }, {
                translationKey: 'nav.user-dashboard.sustainability-managers',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageUsers(),
                navigation: this.navigation.sustainabilityManagers().list()
              }, {
                translationKey: 'nav.user-dashboard.roles',
                // do not show the screen anymore
                displayed: () => false,
                  // this.authService.isAuthenticated() && this.authService.canManageRoles(),
                navigation: this.navigation.roles().list()
              }, {
                translationKey: 'nav.user-dashboard.permissions',
                // do not show the screen anymore
                displayed: () => false,
                // this.authService.isAuthenticated() && this.authService.canManagePermissions() && this.authService.isAuth0Authenticated(),
                navigation: this.navigation.permissions().list()
              },
              {
                translationKey: 'nav.user-dashboard.search',
                displayed: () => this.authService.canSearchUsers(),
                iconClass: 'fa fa-user',
                navigation: this.navigation.userSearch().list()
              }
            ]
          }, {
            translationKey: 'nav.administration.regions',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManageRegions(),
            iconClass: 'fa fa-globe',
            navigation: this.navigation.regions().list()
          }, {
            translationKey: 'nav.manage-plants',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManagePlants(),
            iconClass: 'fa fa-warehouse',
            navigation: this.navigation.managePlants()
          }, {
            translationKey: 'nav.third-party-loads.locations',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManageLocations() || this.authService.canReadLocations(),
            iconClass: 'fa fa-map-marker',
            navigation: this.navigation.localLoads().locations()
          }, {
            translationKey: 'nav.administration.reports-configuration',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManageReports(),
            iconClass: 'fa fa-cog',
            navigation: this.navigation.reportsConfiguration().list()
          }, {
            translationKey: 'nav.administration.global-configuration',
            displayed: () => this.authService.canManageGlobalConfiguration(),
            iconClass: 'fa fa-cog',
            items: [
              {
                translationKey: 'nav.administration.support-configuration',
                displayed: () => this.authService.canManageGlobalConfiguration(),
                navigation: this.navigation.globalConfiguration().support()
              }, {
                translationKey: 'nav.administration.cico-help-configuration',
                displayed: () => this.authService.canManageGlobalConfiguration(),
                navigation: this.navigation.globalConfiguration().cicoHelp()
              }
            ]
      }, {
            translationKey: 'nav.decarbonization',
            displayed: () => this.authService.isAuthenticated() && this.authService.canViewDecarbonizationTypes(),
            iconClass: 'fas fa-leaf',
            navigation: this.navigation.decarbonizationConfiguration().list()
          }
        ]
      }, {
        translationKey: 'nav.load-management',
        displayed: () => this.authService.isAuthenticated() && this.authService.canManageLoads(),
        iconClass: 'fas fa-truck-loading',
        items: [
          {
            translationKey: 'nav.load-management',
            displayed: () => this.authService.isAuthenticated() && this.authService.canViewLoadsManagement(),
            iconClass: 'fas fa-cubes',
            navigation: this.navigation.loadsManagement().searchLoads()
          }, {
            translationKey: 'nav.realtime-tracking.title',
            displayed: () => this.authService.isAuthenticated() && this.authService.canViewLoadTracking(),
            iconClass: 'fa fa-map-marker',
            items: [
              {
                translationKey: 'nav.realtime-tracking.overview',
                displayed: () => this.authService.isAuthenticated() && this.authService.canViewLoadTracking(),
                navigation: this.navigation.realtimeTracking().overview()
              }, {
                translationKey: 'nav.realtime-tracking.map',
                displayed: () => this.authService.isAuthenticated() && this.authService.canViewLoadTracking(),
                navigation: this.navigation.realtimeTracking().map()
              }
            ]
          }, {
            translationKey: 'nav.blue-tracking',
            displayed: () => this.authService.isAuthenticated() && this.authService.canUseOverdue(),
            iconClass: 'fa fa-calendar-alt',
            navigation: this.navigation.overdue().list()
          }, {
            translationKey: 'nav.load-handovers',
            displayed: () => this.authService.isAuthenticated() && this.authService.canReadHandovers(),
            iconClass: 'fas fa-trailer',
            navigation: this.navigation.loadHandovers().map()
          }, {
            translationKey: 'nav.loads-pods-validation',
            displayed: () => this.authService.isAuthenticated() && this.authService.canAccessPodsValidation(),
            iconClass: 'fa fa-file-alt',
            navigation: this.navigation.podsValidation().overall()
          }, {
            translationKey: 'nav.imported-loads',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManageLocalLoads(),
            iconClass: 'fas fa-sync-alt',
            items: [
              {
                translationKey: 'nav.third-party-loads.import',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageLocalLoads(),
                navigation: this.navigation.localLoads().import()
              }, {
                translationKey: 'nav.third-party-loads.find',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageLocalLoads(),
                navigation: this.navigation.localLoads().find()
              }
            ]
          }, {
            translationKey: 'nav.tnx-dashboard',
            displayed: () => this.authService.isAuthenticated() && this.authService.canViewTnxDashboard() && environment.features.tnxDashboard,
            iconClass: 'fas fa-tachometer-alt',
            navigation: this.navigation.tnxDashboard().list()
          }, {
            translationKey: 'nav.webhooks-events',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManageWebhooks(),
            iconClass: 'fa fa-file-alt',
            navigation: this.navigation.webhooksEvents().overall()
          },
          {
            translationKey: 'nav.dedicated-fleet',
            iconClass: 'fa fa-truck',
            displayed: () => this.authService.isAuthenticated() && this.authService.canViewDedicatedFleetManagement(),
            isOpen: false,
            items: [
              {
                translationKey: 'nav.df-master-data',
                displayed: () => this.authService.isAuthenticated() && this.authService.canViewDedicatedFleetManagement(),
                navigation: this.navigation.dfMasterDataManagement().list()
              },
              {
                translationKey: 'nav.df-transaction',
                displayed: () => this.authService.isAuthenticated() && this.authService.canViewDedicatedFleetManagement(),
                navigation: this.navigation.dfTransactionManagemnt().list()
              },
              {
                translationKey: 'nav.df-admin',
                displayed: () => this.authService.isAuthenticated() && this.authService.canViewDedicatedFleetManagement(),
                navigation: this.navigation.dfAdminManagemnt().list()
              },
              {
                translationKey: 'nav.df-schedular',
                displayed: () => this.authService.isAuthenticated() && this.authService.canViewDedicatedFleetManagement(),
                navigation: this.navigation.calendarScreenNavigate().list()
              }
            ]
          }, {
            translationKey: 'nav.truck-journeys',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManageTruckJourneys(),
            iconClass: 'fa fa-route',
            navigation: this.navigation.truckJourneys().search()
          }
        ]
      }, {
        translationKey: 'nav.carrier-management',
        displayed: () => this.authService.isAuthenticated() &&
          (this.authService.canManageCarriers() ||
          this.authService.canManageLiteLoginAccesses() ||
          this.authService.canManageBlueyonderUser()),
        iconClass: 'fa fa-truck',
        items: [
          {
            translationKey: 'nav.carrier-management',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManageDrivers(),
            iconClass: 'fa fa-truck',
            items: [
              {
                translationKey: 'nav.carrier-configuration',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageDrivers(),
                navigation: this.navigation.selfCarrier().editOwn()
              }, {
                translationKey: 'nav.carrier-managers',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageDrivers(),
                navigation: this.navigation.selfCarrier().carrierManager().list()
              }, {
                translationKey: 'nav.drivers-list',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageDrivers(),
                navigation: this.navigation.selfCarrier().drivers().list()
              }, {
                translationKey: 'nav.sub-carriers',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageDrivers(),
                navigation: this.navigation.selfCarrier().subcontractors().list()
              }, {
                translationKey: 'nav.by-user',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageBlueyonderUserCarrier(),
                navigation: this.navigation.blueyonderUsers().list()
              }
            ]
          }, {
            translationKey: 'nav.carrier-management',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManageCarriers(),
            iconClass: 'fa fa-truck',
            navigation: this.navigation.carriers().list()
          }, {
            translationKey: 'nav.lite-login',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManageLiteLoginAccesses(),
            iconClass: 'fas fa-hourglass-start',
            navigation: this.navigation.liteLogin().list()
          }, {
            translationKey: 'nav.by-user',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManageBlueyonderUserAllCarriers(),
            iconClass: 'fa fa-user',
            navigation: this.navigation.blueyonderUsers().list()
          },
        ]
      }, {
        translationKey: 'nav.reports.reports',
        displayed: () => this.authService.isAuthenticated() && this.authService.canMonitorGlobal(),
        iconClass: 'fas fa-chart-bar',
        items: [
          {
            translationKey: 'nav.log-events',
            displayed: () => this.authService.isAuthenticated() && this.authService.canReadLogEvents(),
            iconClass: 'fa fa-align-justify',
            navigation: this.navigation.logEvents()
          }, {
            translationKey: 'nav.hotspot-tracking.hotspot-tracking',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManageHotspots(),
            iconClass: 'fas fa-exclamation-triangle',
            items: [
              {
                translationKey: 'nav.hotspot-tracking.map',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageHotspots(),
                navigation: this.navigation.hotspots().map()
              },
              {
                translationKey: 'nav.hotspot-tracking.list',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageHotspots(),
                navigation: this.navigation.hotspots().list()
              },
              {
                translationKey: 'nav.hotspot-tracking.alerts',
                displayed: () => this.authService.isAuthenticated() && this.authService.canManageHotspots(),
                navigation: this.navigation.hotspots().alerts()
              },
            ]
          }, {
            translationKey: 'nav.reports.forced-checkin',
            displayed: () => this.authService.isAuthenticated() &&
              (this.authService.canReadForcedCheckin() || this.authService.canReadCarrierForcedCheckin()),
            iconClass: 'fa fa-map-marker',
            navigation: this.navigation.forcedCheckin()
          }, {
            translationKey: 'nav.reports.assets',
            displayed: () => this.authService.isAuthenticated() && this.authService.canManageAssets(),
            iconClass: 'fa fa-pallet',
            navigation: this.navigation.assets().list()
          }, {
            translationKey: 'nav.reports.power-bi-reports',
            displayed: () => this.authService.isAuthenticated() && this.authService.canReadReports(),
            iconClass: 'fa fa-file-alt',
            navigation: this.navigation.reports().list()
          }, {
            translationKey: 'nav.monitoring.status',
            displayed: () => this.authService.isAuthenticated() && this.authService.canMonitorApi(),
            iconClass: 'mc-status',
            navigation: this.navigation.monitoring().status()
          }, {
            translationKey: 'nav.monitoring.http',
            displayed: () => this.authService.isAuthenticated() && this.authService.canMonitorApi(),
            iconClass: 'fa fa-wifi',
            navigation: this.navigation.monitoring().http()
          }
        ]
      }
    ];
  }

  findNavigation(navItem: NavItem) {
    return (!!navItem.navigation && this.router.isActive(navItem.navigation.getUri(), true)) ||
      navItem.items?.some(item => this.findNavigation(item));
  }

  login() {
    if (this.isUserDropdownOpen) {
      this.isUserDropdownOpen = false;
    }

    if (!this.isCollapsed) {
      this.toggleSideMenu();
    }

    this.navigation.login().go();
  }

  logout() {
    if (this.isUserDropdownOpen) {
      this.isUserDropdownOpen = false;
    }

    if (!this.isCollapsed) {
      this.toggleSideMenu();
    }

    this.navigation.logout().go();
  }

  toggleSideMenu(): void {
    this.refreshCurrentItem();
    if (this.isCollapsed === true) {
      this.isCollapsed             = false;
      this.isSideMenuContainerShow = true;
      setTimeout(() => {
        this.isSideMenuShow = true;
      }, 50);
    } else {
      this.selectedMenu   = null;
      this.subMenuOpen    = false;
      this.isCollapsed    = true;
      this.isSideMenuShow = false;
      setTimeout(() => {
        this.isSideMenuContainerShow = false;
      }, 10);
    }
  }

  selectMenuItem(menuItem: NavItem) {
    if (this.selectedMenu === menuItem) {
      this.selectedMenu = null;
      this.subMenuOpen = false;
    } else {
      this.selectedMenu = menuItem;
      this.subMenuOpen = true;
    }
  }

  refreshCurrentItem() {
    this.selectedMenu = this.navItems.find(navItem => this.findNavigation(navItem));
    this.subMenuOpen = !!this.selectedMenu
  }

  requestPasswordChange() {
    this.authService.requestPasswordChange().subscribe(url => {
      window.location.href = url;
      console.log(url);
    }, (error: HttpErrorResponse) => {
      console.log(error);
      this.toastr.error(error.error.message || 'Error while trying to reset password', 'Error');
    });
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
    this.userProfileSubscription.unsubscribe();
  }

  headerClick() {
    const now = moment();

    if (now.diff(this.headerLastClick, 'milliseconds') < 1000) {
      this.headerClickCount++;
    } else {
      this.headerClickCount = 1;
    }

    this.headerLastClick = now;

    if (this.headerClickCount === 5) {
      this.headerClickCount = 0;
      this.navigation.localLoads()
        .manual()
        .go();
    }
  }
}
